export type Subtract<T extends K, K> = Omit<T, keyof K>

/**
 * Convenience method to allow boolean expressions in situations where undefined is required. This allows
 * avoiding ternary operators where you want to express a value if something else is true, and use `undefined`
 * otherwise.
 *
 * Ex: <MyComponent myProp={orUndef(ifThis && myVal)} />
 * @param val
 */
export const orUndef = <T>(val: T | boolean | null | undefined): T | undefined =>
  (val as T) || undefined

export type MakeOptional<T, K extends string | number | symbol> = Omit<T, K> & Partial<T>

export type Nullable<T> = T | null

export type MakeNullable<T> = { [K in keyof T]: T[K] | null }
